module.exports = __webpack_public_path__ + "img/wildberries.7d15a321.png";